import {
  GET_EMPLOYESS,
  CREATE_EMPLOYEE,
  DELETE_EMPLOYEE,
  EDIT_EMPLOYEE,
  SET_SIDEBAR_RIGHT,
  SET_SELECTED_EMPLOYEE,
} from '../../constants/ActionTypes';
import { fetchAsync } from '../../util/fetchers';
import { urlEmployee } from '../../util/globals';

export default (state, dispatch) => ({

  getEmployees: () => {
    return fetchAsync(urlEmployee, "", "GET", "")
      .then((payload) => {
        dispatch({ type: 'GET_EMPLOYESS', payload });
        return payload;
      })
  },

  createEmployee: (employeeData) => {
    return fetchAsync(urlEmployee, JSON.stringify(employeeData), "POST", "")
      .then((payload) => {
        dispatch({ type: CREATE_EMPLOYEE, payload });
        return payload;
      })
  },

  editEmployee: (employeeData, _idEmployee) => {
    return fetchAsync(urlEmployee + `/${_idEmployee}`, JSON.stringify(employeeData), "PUT", "")
      .then((payload) => {
        dispatch({ type: EDIT_EMPLOYEE, payload });
        return payload;
      })
  },

  deleteEmployee: (_idEmployee) => {
    return fetchAsync(urlEmployee + `/${_idEmployee}`, "", "DELETE", "")
      .then((payload) => {
        dispatch({ type: DELETE_EMPLOYEE, payload });
        return payload;
      })
  },

  setIsSidebarRightOpen: () => {
    dispatch({ type: SET_SIDEBAR_RIGHT, payload: { success: true } });
  },

  setSelectedEmployee: (employeeData) => {
    dispatch({ type: SET_SELECTED_EMPLOYEE, payload: { success: true, employeeData } });
  },

});